document.addEventListener('DOMContentLoaded', () => {
  const openButton = document.querySelector('.open-size-chart-drawer');

  if (openButton) {
    openButton.addEventListener('click', () => {
      const event = new CustomEvent('dispatch:size-chart-drawer:open', {
        detail: {
          opener: openButton, // Optional, can be used if you need to know which element opened the drawer
        }
      });
      document.dispatchEvent(event);
    });
  }
});

class SizeChartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:size-chart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:size-chart-drawer:close', this.closeDrawerViaEventHandler);
    this.addEventListener('on:size-chart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:size-chart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:size-chart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
    this.loadSizeChartContent(); // Ensure the content is loaded
  }

  loadSizeChartContent() {
    const sizeChartContent = document.querySelector('.size-chart-content');
    if (sizeChartContent) {
      // Load content dynamically if necessary
      // This example assumes the content is already injected
      // If not, you might need to fetch it via an API or similar method
    }
  }
}

window.customElements.define('size-chart-drawer', SizeChartDrawer);
